module.exports = __webpack_public_path__ + "img/marker-green-48.f5c4b104.png";